import { render, staticRenderFns } from "./SalesRecordDetails.vue?vue&type=template&id=d88965fa&"
import script from "./SalesRecordDetails.vue?vue&type=script&lang=js&"
export * from "./SalesRecordDetails.vue?vue&type=script&lang=js&"
import style0 from "./SalesRecordDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports